import { useSyncExternalStore } from 'react';

const TOKEN_KEY = 'dz_access_token';
const AUTH_EVENT = 'dz-auth-change';

function emitAuthChange() {
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function getAccessToken(): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function setAccessToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
  emitAuthChange();
}

export function clearAccessToken() {
  localStorage.removeItem(TOKEN_KEY);
  emitAuthChange();
}

export function isAuthenticated(): boolean {
  return Boolean(getAccessToken());
}

function subscribe(onStoreChange: () => void) {
  window.addEventListener('storage', onStoreChange);
  window.addEventListener(AUTH_EVENT, onStoreChange);
  return () => {
    window.removeEventListener('storage', onStoreChange);
    window.removeEventListener(AUTH_EVENT, onStoreChange);
  };
}

export function useIsAuthenticated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => Boolean(localStorage.getItem(TOKEN_KEY)),
    () => false,
  );
}
